/**
 * Divider — Separador horizontal ou vertical, com label opcional
 */
import { T } from '../../styles/tokens';

interface DividerProps {
  /** Direção */
  direction?: 'horizontal' | 'vertical';
  /** Label no meio do separador */
  label?: string;
  /** Margem vertical/horizontal */
  spacing?: number;
}

export function Divider({ direction = 'horizontal', label, spacing = T.space4 }: DividerProps) {
  if (direction === 'vertical') {
    return (
      <div style={{
        width: 1,
        alignSelf: 'stretch',
        background: T.border,
        margin: `0 ${spacing}px`,
        flexShrink: 0,
      }} />
    );
  }

  if (label) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: T.space3,
        margin: `${spacing}px 0`,
      }}>
        <div style={{ flex: 1, height: 1, background: T.border }} />
        <span style={{ fontSize: T.textSm, color: T.textMuted, fontWeight: T.weightMedium, whiteSpace: 'nowrap' }}>
          {label}
        </span>
        <div style={{ flex: 1, height: 1, background: T.border }} />
      </div>
    );
  }

  return (
    <div style={{
      height: 1,
      background: T.border,
      margin: `${spacing}px 0`,
    }} />
  );
}
